export default "__VITE_ASSET__B7wZ2wz___"